import { useEffect, useState, type CSSProperties } from 'react';

type Props = {
  pct: number;
  color?: string;
  className?: string;
  duration?: number;
  style?: CSSProperties;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

// A horizontal bar fill that animates from 0% to its target width on mount.
// React commits with width=0, paints once, then useEffect bumps to the real
// value — the CSS transition handles the rest.
export function ProgressFill({
  pct,
  color,
  className = '',
  duration = 700,
  style,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    setWidth(pct);
  }, [pct]);
  return (
    <div
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        ...style,
        width: `${width}%`,
        background: color,
        transition: `width ${duration}ms cubic-bezier(0.22, 1, 0.36, 1), opacity 0.22s ease`,
      }}
    />
  );
}
